export enum ApiDataExportType {
  users = "users",
  waitlist = "waitlist",
  cardAccounts = "card_accounts",
  cardUsage = "card_usage",
  usersForAnalytics = "users_for_analytics",
}
